define('ItemKeyMapping.ComparePriceFix', [
    'SC.Configuration',

    'underscore'
], function ItemKeyMappingComparePriceFix(
    Configuration,

    _
) {
    'use strict';

    Configuration.itemKeyMapping = Configuration.itemKeyMapping || {};

    /**
     * TODO: Analyze specific cases where defaulting to base price may not
     * make sense when there is _priceDetails but no priceschedule
     */
    _.extend(Configuration.itemKeyMapping, {
        _comparePriceAgainst: function _comparePriceAgainst(item) {
            var prices = item.get('_priceDetails');

            if (prices) {
                if (prices.priceschedule) {
                    return prices.priceschedule[0].price;
                }
            }

            return item.get('pricelevel1');
        },

        _comparePriceAgainstFormated: function _comparePriceAgainstFormated(item) {
            var prices = item.get('_priceDetails');

            if (prices) {
                if (prices.priceschedule) {
                    return prices.priceschedule[0].price_formatted;
                }
            }

            return item.get('pricelevel1_formatted');
        }
    });
});

